import React, { createContext, useContext, useEffect, useState } from 'react';

const TravelContext = createContext();

const LOCAL_STORAGE_KEY = 'favoriteDestinations';

const getInitialFavorites = () => {
  try {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};

const initialDestinations = [
  {
    id: 1,
    name: 'Bali, Indonesia',
    image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751666930/pexels-photo-2260031_iulqdr_toffft.jpg',
    short: 'Sacred temples, lush jungles, and pristine beaches blend in Bali’s magical escape.',
    description:
      'Experience the island of gods where tradition meets modern joy. Explore the mystical temples of Tanah Lot, breathe in the peace of Ubud’s emerald rice terraces, and soak up the energy of lively beach clubs. Bali offers healing retreats, adrenaline-pumping surf, and a cultural heartbeat that leaves every traveler transformed.',
    highlights: [
      { name: 'Pura Ulun Danu', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751666985/photo-1680094513147-a9b7ce9b209b_icyylf_r1zedl.jpg' },
      { name: 'Kuta Beach', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667006/pexels-photo-6208345_llkwk1_v4kxqu.jpg' },
      { name: 'Tanah Lot Temple', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667039/pexels-photo-17299295_zyqpcg_gqtkxx.jpg' },
      { name: 'Sacred Monkey Forest', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667052/photo-1693276206509-e8a32cb3ce19_r3wc00_a0zsn7.jpg' }
    ],
    location: 'Indonesia',
    bestTime: 'April to October',
    theme: 'Spiritual wellness and tropical adventures.',
    price: 1299, // USD per person
    duration: '7 days / 6 nights',
    tag: 'trending'
  },
  {
    id: 2,
    name: 'Tokyo, Japan',
    image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667093/pexels-photo-3917809_e6kpst_augpec.jpg',
    short: 'Where ancient shrines meet neon-lit nights and world-class culinary art.',
    description:
      'Tokyo is a city of contrasts, where peaceful gardens coexist with futuristic skyscrapers. Witness the graceful rituals at Senso-ji Temple, savor Michelin-star ramen, and get lost in the buzz of Shibuya Crossing. Whether you want cherry blossoms in spring or colorful festivals in fall, Tokyo offers endless discoveries for every traveler.',
    highlights: [
      { name: 'Shibuya Crossing', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667119/photo-1549693578-d683be217e58_hwphij_qhaoxx.jpg' },
      { name: 'Senso-ji Temple', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667141/photo-1713917457116-f0b5d968a238_zej5qi_h6y2zw.jpg' },
      { name: 'Tokyo Tower', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667156/photo-1606044466411-207a9a49711f_f4q9ro_gsrjba.jpg' },
      { name: 'Ueno Park', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667172/photo-1558452919-3a47422e2fd0_k9xbtx_hsqnai.jpg' }
    ],
    location: 'Japan',
    bestTime: 'March to May, October to November',
    theme: 'Urban exploration with serene cultural retreats.',
    price: 1850, // USD per person
    duration: '6 days / 5 nights',
    tag: 'trending'
  },
  {
    id: 3,
    name: 'Santorini, Greece',
    image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667214/photo-1661602715715-4db69e772aa3_jcv6kn.jpg',
    short: 'Romantic sunsets, blue domes, and unforgettable Aegean sea views.',
    description:
      'Santorini is a postcard come to life. Wander the cliffside villages of Oia, sip local volcanic wines, and discover the ruins of ancient Akrotiri. Swim in crystal-clear waters, lounge on black-sand beaches, and witness the most famous sunsets in the world. This island blends Greek tradition with luxury for a perfect Mediterranean dream.',
    highlights: [
      { name: 'Oia Sunset', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667234/photo-1672622851784-0dbd3df4c088_kxtzvy_k1ekye.jpg' },
      { name: 'Red Beach', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667251/photo-1669222837648-dff0341037b7_zqyv7b_ysavx2.jpg' },
      { name: 'Ancient Akrotiri', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667268/photo-1575210026707-3f0cb75a2692_q6bdse_zc3sry.jpg' },
      { name: 'Fira Town', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667311/photo-1693775253063-bedfed538342_dhbjez_uunjru.jpg' }
    ],
    location: 'Greece',
    bestTime: 'May to October',
    theme: 'Romantic seaside luxury with history and wine tasting.',
    price: 2100, // USD per person
    duration: '5 days / 4 nights',
    tag: 'romantic'
  },
  {
    id: 4,
    name: 'Kerala Backwaters, India',
    image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667372/photo-1609828913552-f9138ed9e42d_ttsvas_olplzj.jpg',
    short: 'Calm canals, coconut groves, and houseboat living at its finest.',
    description:
      'Kerala’s backwaters offer a slow, soothing pace of life perfect for deep relaxation. Cruise through shimmering lakes and narrow canals on a traditional houseboat, experience authentic South Indian hospitality, and enjoy Ayurveda wellness rituals. Watch local fishermen at work and taste delicious fish curries, all against a backdrop of swaying palms.',
    highlights: [
      { name: 'Alleppey Houseboat', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667389/photo-1593693397690-362cb9666fc2_zb9bb1_xteczc.jpg' },
      { name: 'Kumarakom Bird Sanctuary', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667407/photo-1732771713762-6a1a7534bd0f_b7w4xi_utjk4m.jpg' },
      { name: 'Fort Kochi', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667432/photo-1590123717647-de5b78ed762e_iqfh56_jjlslh.jpg' }
    ],
    location: 'India',
    bestTime: 'November to February',
    theme: 'Slow living with authentic South Indian culture and wellness.',
    price: 950, // USD per person
    duration: '4 days / 3 nights',
    tag: 'nature'
  },
  {
  id: 5,
  name: 'Paris, France',
  image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667570/photo-1502602898657-3e91760cbb34_xepman.jpg',
  short: 'Romance, world-class art, and unforgettable cuisine in the City of Light.',
  description:
    'Stroll the romantic boulevards of Paris, from the Eiffel Tower to Montmartre. Enjoy fine dining, explore the Louvre, and cruise the Seine by night. Discover centuries of art, architecture, and French flair in one of the most iconic cities on earth.',
  highlights: [
    { name: 'Eiffel Tower', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667612/R.9f0633e930516f6ff470595268f58b27_fd9r5e.jpg' },
    { name: 'Louvre Museum', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667741/louvre_qtnorr.jpg' },
    { name: 'Seine River Cruise', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667787/Bateau-Mouche-cruising-on-Seine-river-at-sunset-Paris.-min_q7boui.jpg' }
  ],
  location: 'France',
  bestTime: 'April to June, September to November',
  theme: 'Romantic and cultural immersion.',
  price: 2400,
  duration: '6 days / 5 nights',
  tag: 'romantic'
},
{
  id: 6,
  name: 'Rome & Amalfi Coast, Italy',
  image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667919/amalfi-town-2-coast-italy-tours_vtztwa.jpg',
  short: 'Ancient ruins and coastal beauty in Italy’s most beloved regions.',
  description:
    'Start in Rome with the Colosseum, Vatican City, and pasta in Trastevere, then head to the stunning Amalfi Coast for cliffside views, colorful fishing villages, and Mediterranean sunshine. This tour blends history with luxury relaxation.',
  highlights: [
    { name: 'Colosseum', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751667957/colosseum-rome-italy-27058903_yt8ivg.jpg' },
    { name: 'Positano', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751668021/Home3_advxpp.jpg' },
    { name: 'Vatican City', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751668068/4a493c2b6fa2e6baa39693ab44443d61-vatican_20city_20aerial_20view_crjtqt.jpg' }
  ],
  location: 'Italy',
  bestTime: 'April to June, September to October',
  theme: 'Historical and coastal luxury.',
  price: 2850,
  duration: '8 days / 7 nights',
  tag: 'history'
},
{
  id: 7,
  name: 'Dubai & Abu Dhabi, UAE',
  image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751668170/discovering-the-7-emirates-of-uae-abu-dhabi-dubai-sharjah-ajman-umm-al-quwain-ras-al-khaimah-and-fujairah-651ab129ba369_wa1jct.jpg',
  short: 'Futuristic skyscrapers meet desert adventure and luxury shopping.',
  description:
    'Experience the ultra-modern skyline of Dubai with the Burj Khalifa, luxury malls, and thrilling desert safaris. Then visit Abu Dhabi’s Sheikh Zayed Mosque and Louvre Abu Dhabi for art, culture, and architectural wonder.',
  highlights: [
    { name: 'Burj Khalifa', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751668244/1_Burj_Khalifa_verticale_xh4wqj.jpg' },
    { name: 'Sheikh Zayed Mosque', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751668291/e0b85a136d0bc78aa4528a7671be149b_fuklks.jpg' },
    { name: 'Desert Safari', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751668364/b5_ltqfli.jpg' }
  ],
  location: 'United Arab Emirates',
  bestTime: 'November to March',
  theme: 'Luxury, shopping, and desert adventure.',
  price: 3200,
  duration: '7 days / 6 nights',
  tag: 'luxury'
},
{
  id: 8,
  name: 'Thailand Highlights',
  image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751668453/Wat-Arun-the-temple-of-dawn-1-1024x569_luta4g.jpg',
  short: 'Temples, tropical islands, and unforgettable street food adventures.',
  description:
    'Combine bustling Bangkok with the peaceful beaches of Phuket and Phi Phi Islands. Visit ornate temples, ride a longtail boat, and sample delicious Thai cuisine. Thailand offers incredible hospitality and an unbeatable price-to-value ratio.',
  highlights: [
    { name: 'Grand Palace', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751668498/OIP_amtzxy.webp' },
    { name: 'Phi Phi Islands', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751668543/phiphi-island_tswi0i.jpg' },
    { name: 'Wat Pho', image: 'https://res.cloudinary.com/dyuskzmn3/image/upload/v1751668579/37_t4tsrs.jpg' }
  ],
  location: 'Thailand',
  bestTime: 'November to February',
  theme: 'Beach, temples, and culinary adventures.',
  price: 1750,
  duration: '9 days / 8 nights',
  tag: 'beach'
}

];

export const TravelProvider = ({ children }) => {
  const [destinations, setDestinations] = useState(initialDestinations);
  const [selectedDestination, setSelectedDestination] = useState(null);
  const [favorites, setFavorites] = useState(getInitialFavorites);

  const getDestinationBySlug = (slug) =>
  destinations.find(d =>
    d.name
      .toLowerCase()
      .replace(/[,]/g, '')      
      .replace(/\s+/g, '-')      
      === slug
  );

  const toggleFavorite = (destination) => {
    const exists = favorites.some(d => d.id === destination.id);
    const updated = exists
      ? favorites.filter(d => d.id !== destination.id)
      : [...favorites, destination];

    setFavorites(updated);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updated));
  };

  const isFavorite = (destinationId) => favorites.some(d => d.id === destinationId);

  return (
    <TravelContext.Provider
      value={{
        destinations,
        selectedDestination,
        setSelectedDestination,
        getDestinationBySlug,
        favorites,
        toggleFavorite,
        isFavorite
      }}
    >
      {children}
    </TravelContext.Provider>
  );
};

export const useTravelContext = () => useContext(TravelContext);
